window.Autocomplete = {
  ResultRenderers: {
    // A generic function to use when rendering Record results
    record: function (ul, item) {
      var icon = jQuery("<span>", { class: "autocomplete-icon" }).html(item.icon);
      var text = jQuery("<span>", { class: "autocomplete-text" });
      text.append(jQuery("<span>", { class: "autocomplete-label" }).text(item.label));

      if (item.identifier) {
        text.append(jQuery("<span>", { class: "autocomplete-identifier" }).text(item.identifier));
      }

      return jQuery("<li>", { class: "autocomplete-result" }).append(icon, text).appendTo(ul);
    },
  },
};
